import React from "react";
import { Helmet } from "react-helmet-async";
import { buildBreadcrumb } from "@/utils/schema";

const DEFAULT_IMAGE = "https://customer-assets.emergentagent.com/job_premium-celebrations-14/artifacts/ne75w843_Asset%201%4018x.png";
const SITE_URL = process.env.REACT_APP_SITE_URL || "https://petalspromises.com";

export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  keywords,
  jsonLd,           // single object or array of JSON-LD objects
  breadcrumbLast,   // optional override for the last breadcrumb label (e.g. blog title)
  noBreadcrumb = false,
}) {
  const fullTitle = title
    ? `${title} · Petals & Promises`
    : "Petals & Promises — Luxury Event Management, Weddings & Corporate Events";
  const desc =
    description ||
    "Petals & Promises designs, plans, and executes luxury weddings, intimate celebrations, corporate events, and devotional gatherings with elegance, emotion, and flawless attention to detail.";
  const url = `${SITE_URL}${path}`;
  const kw =
    keywords ||
    "event management company, wedding planner Gurgaon, wedding planner Chandigarh, luxury wedding planner India, destination wedding planner, corporate event management, event decor services, catering services for events, venue booking for weddings, premium event company, devotional events, jagran mata ki chowki planner, social celebration planner";

  // Always attach BreadcrumbList unless explicitly disabled
  const breadcrumbLd = noBreadcrumb ? null : buildBreadcrumb(path, breadcrumbLast);
  const lds = [];
  if (jsonLd) {
    if (Array.isArray(jsonLd)) lds.push(...jsonLd);
    else lds.push(jsonLd);
  }
  if (breadcrumbLd) lds.push(breadcrumbLd);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={fullTitle} />
      <meta property="og:site_name" content="Petals & Promises" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={fullTitle} />

      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="author" content="Petals & Promises" />

      {lds.map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
}
